import { render, staticRenderFns } from "./PurchaseOrderEmailModal.vue?vue&type=template&id=b21cd6e8&"
import script from "./PurchaseOrderEmailModal.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports